export default __webpack_public_path__ + "static/media/criminal4.a541291d.jpg";